//fichiers pour le bulles
import bubblecss from "../../bubbles/dist/main.css";
import bubbleCalcul from "../../bubbles/dist/main.js";
import bubbleAnim from "../../bubbles/dist/anims.js";

//charte + grid
// import framework from "../../framework/dist/main.css";

//fichier CSS principal
import style from "./styles/style.scss";

//tag XITI
import xiti from "./scripts/data-xiti.js";

import Swiper from "swiper/dist/js/swiper.min.js";
import SwiperCSS from "swiper/dist/css/swiper.css";

//plugin de lazyloading
import lazy from "lazysizes";
window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.srcAttr = 'data-lazy';
window.lazySizesConfig.expand = 350;

//js des push produits
// import pushProds from "./scripts/managePushProds.js";

$j(document).ready(function(){

	$j.slider = new Swiper('.swiper-container', {
		speed: 400,
		slidesPerView: 1,
		spaceBetween: 0,
		autoHeight:true,
		loop: false,
		threshold :5000,
		noSwiping : true,
		hashNavigation: {
			replaceState: true,
		},
		breakpoints: {
			1030: {
				threshold : 20
			},
		}
	});

	$j.mq = window.getComputedStyle(document.querySelector("body"), ":before").getPropertyValue("content").replace(/'/g, "").replace(/"/g, "");
	$j(window).on("resize", function(){
		$j.mq = window.getComputedStyle(document.querySelector("body"), ":before").getPropertyValue("content").replace(/'/g, "").replace(/"/g, "");
	});

	$j(".intro__block").on("click", function(){
		if($j.mq == "mobile"){
			$j(this).toggleClass("display").find(".intro__content").slideToggle();
		}
	});

    $j('.menu__link').on("click", function(e){
		e.preventDefault();

		if($j.mq == "mobile"){
			$j(".menu__link--actif").removeClass("menu__link--actif")
			$j(this).addClass("menu__link--actif");

			$j.slider.slideTo($j(this).parent().index(), 1);

			$j("body, html").animate({
				scrollTop: $j(".page-enki").offset().top
			}, 500, function(){
				$j.slider.update()
			});
			$j(".container-desk").slideUp();
			$j(".swiper-container").slideDown(function(){
				$j.slider.update()
			});

		}else{
			if(!$j(this).hasClass("menu__link--actif")){
				//location.hash = $j(this).attr("href");
				$j(".menu__link--actif").removeClass("menu__link--actif")
				$j(this).addClass("menu__link--actif");

				$j.slider.slideTo($j(this).parent().index());
			}
		}
	});
	if($j.mq == "mobile"){
		$j('.menu__link').removeClass("menu__link--actif");
	}else{
		$j('.menu__link[href='+ location.hash +']').trigger("click");
	}

	$j(".scenario__close").on("click", function(e){
		e.preventDefault();

		$j(".menu__link--actif").removeClass("menu__link--actif");
		$j(".container-desk").slideDown();
		$j(".swiper-container").slideUp();
	})

	$j(window).on("hashchange", function(e){
		e.preventDefault();
	});


})